import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { TeamMemberData } from '@core/tellent-assistant-types';

import { ListCardComponent } from '../../list-card/list-card.component';
import { ListRowPersonComponent } from '../../rows/list-row-person.component';

@Component({
  selector: 'rt-list-item-team-member',
  imports: [ListCardComponent, ListRowPersonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-assistant-list-card>
      <rt-list-row-person [data]="data()" />
    </rt-assistant-list-card>
  `,
})
export class ListItemTeamMemberComponent {
  public readonly data = input.required<TeamMemberData>();
}
